import { render, staticRenderFns } from "./menuDriver.vue?vue&type=template&id=8ba020d6&scoped=true"
import script from "./menuDriver.vue?vue&type=script&lang=js"
export * from "./menuDriver.vue?vue&type=script&lang=js"
import style0 from "./menuDriver.vue?vue&type=style&index=0&id=8ba020d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba020d6",
  null
  
)

export default component.exports